import BaseModel from 'src/model/base.model';

class LocationModel extends BaseModel {
  public code: string = '';
  public name: string = '';
  public addressLine1: string = '';
  public addressLine2: string = '';
  public addressLine4: string = '';
  public stateCode: string = '';
  public postalCode: string = '';
}

export default LocationModel;
